module.exports = __webpack_public_path__ + "static/media/akali.ac371d6c.png";